var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board"
  }, [_c('v-expansion-panels', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l(_vm.faqs, function (faq, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', [_c('p', {
      staticClass: "category mb-4 mb-lg-0"
    }, [_vm._v(_vm._s(faq.type))]), _c('p', {
      staticClass: "tit-en font-size-16 font-size-lg-24 font-weight-bold color-primary"
    }, [_vm._v("Q")]), _c('p', {
      staticClass: "page-text font-weight-bold"
    }, [_vm._v(_vm._s(faq.subject))])]), _c('v-expansion-panel-content', [_c('p', {
      staticClass: "tit-en page-text--sm font-weight-bold",
      staticStyle: {
        "color": "#555"
      }
    }, [_vm._v("A")]), _c('p', {
      staticClass: "page-text--sm",
      staticStyle: {
        "color": "#777"
      },
      domProps: {
        "innerHTML": _vm._s(faq.content.replace(/\n/g, '<br>'))
      }
    })])], 1);
  }), 1), _vm._m(0)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "text-16 text-md-14 color-primary text-right"
  }, [_vm._v("찾으시는 질문이 없으신 경우 1:1문의를 이용해 주시기 바랍니다.")])]);
}]

export { render, staticRenderFns }